import React, { Component } from 'react';

import { isBrowser } from '../../../lib/utils';
import ServiceModalCards from './ServiceModalCards';
import { sliderVisible } from '../../../constants/limits';

let Slider = '';
if (isBrowser()) {
  Slider = require('react-slick').default;
  require('slick-carousel/slick/slick.css');
  require('slick-carousel/slick/slick-theme.css');
}

function GalleryNextArrow(props) {
  const {
    className,
    onClick,
    themesArray,
    loadMoreCards,
    currentSlide,
    loading,
    isLastPage,
  } = props;
  const shouldLoadMore = currentSlide >= themesArray.length - 4;

  return (
    <div
      className={
        shouldLoadMore
          ? !isLastPage
            ? !loading
              ? 'control right loadable'
              : 'control right loading'
            : `control right ${className}`
          : `control right ${className}`
      }
    >
      <div
        className="circle"
        /**when the user click on next arrow, in order to restrict api calls,
         return an empty function instead of what it was otherwise supposed to do**/
        onClick={() => {
          // eslint-disable-next-line
          loading
            ? () => {}
            : /**if the necessary condition is true, load more cards otherwise call the
               slick onClick method that changes the slide to next element in line**/
            shouldLoadMore
            ? !isLastPage
              ? loadMoreCards()
              : onClick()
            : onClick();
        }}
      >
        <i className="icon icon-hg-chev-right" />
      </div>
    </div>
  );
}

function GalleryPrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div>
      <div className={`control left ${className}`}>
        <div className="circle" onClick={onClick}>
          <i className="icon icon-hg-chev-left" />
        </div>
      </div>
    </div>
  );
}

export default class ServiceModalSlider extends Component {
  state = {
    loading: false,
    activeSlide: 0,
    shouldLoadMore: false,
  };

  componentDidUpdate(prevProps) {
    if (sliderVisible) {
      if (prevProps.configs.categories !== this.props.configs.categories) {
        /**when user changes categories, move slick to first card
        Because the user might have been swiping the slider and might be at position other
        than the initial position so in order to make sure that the slider return
        to the initial postion, slickGoTo function is called with 0 as argument which moves
        the slider to initial position **/
        this.slider.slickGoTo(0);
      }
      if (prevProps.configs.searchTerm !== this.props.configs.searchTerm) {
        //when user changes searchTerm, move slick to first card
        this.slider.slickGoTo(0);
      }
      if (prevProps.slideIndex !== this.props.slideIndex) {
        /**when user click either prev or next in the theme description modal,
         move the slider to the corresponding slide index **/
        this.slider.slickGoTo(this.props.slideIndex);
      }
    }
  }

  render() {
    const {
      themesArray,
      cardsArray,
      theme,
      toggleAlert,
      openSlider,
      isLastPage,
      placeName,
      dayDate,
    } = this.props;
    const { loading } = this.state;

    const sliderSettings = {
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipe: true,
      nextArrow: (
        <GalleryNextArrow
          themesArray={themesArray}
          loadMoreCards={this.onloadMore}
          loading={loading}
          isLastPage={isLastPage}
        />
      ),
      prevArrow: <GalleryPrevArrow />,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            swipe: true,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            swipe: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            swipe: true,
          },
        },
        {
          breakpoint: 768,
          settings: 'unslick',
        },
        {
          breakpoint: 500,
          settings: 'unslick',
        },
      ],
    };
    return (
      <Slider
        className="sk-slider"
        {...sliderSettings}
        ref={sliderRef => (this.slider = sliderRef)}
      >
        {themesArray.map((themeObj, i) => {
          return (
            <div key={`${themeObj.id}`} className="item">
              <ServiceModalCards
                themes={themesArray}
                cardsArray={cardsArray}
                cardData={themeObj}
                theme={theme}
                slideIndex={i}
                openSlider={openSlider}
                toggleAlert={toggleAlert}
                placeName={placeName}
                dayDate={dayDate}
                modalType={'trekDayEdit'}
              />
            </div>
          );
        })}
      </Slider>
    );
  }

  onloadMore = () => {
    const { configs, getPlaceThemes } = this.props;
    const { limit, page, searchTerm, categories } = configs;
    this.setState({ loading: true });

    getPlaceThemes({ limit, page: page + 1, categories, searchTerm }).then(() => {
      this.setState({ loading: false });
      if (sliderVisible) {
        this.slider.slickNext();
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/screens/Trek/ServiceModal/ServiceModalSlider.jsx